"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleFilters = void 0;
const react_1 = __importStar(require("react"));
const CollapsibleFilters_styles_1 = require("./CollapsibleFilters.styles");
const button_1 = __importStar(require("@kyruus/button"));
const SortFilter_1 = __importDefault(require("@kyruus/react-ikons/SortFilter"));
const ui_theme_1 = require("@kyruus/ui-theme/");
const intl_1 = require("@kyruus/intl");
const WeekDayFilter_1 = require("../WeekDayFilter");
const TimeFilter_1 = require("../TimeFilter");
const messages_1 = __importDefault(require("../../../lib/messages"));
const moment_1 = __importDefault(require("moment"));
const JumpToDate_1 = require("./JumpToDate");
const styles_1 = require("../styles");
const utils_1 = require("../../../lib/utils");
const VisitTypeContent_1 = __importDefault(require("../VisitTypeContent"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const defaultsDeepAll_1 = __importDefault(require("lodash/fp/defaultsDeepAll"));
const reducer = (state, action) => {
    var _a;
    switch (action.type) {
        case 'setSelectedLocations': {
            return Object.assign(Object.assign({}, state), { current: Object.assign(Object.assign({}, state.current), { selectedLocationIds: action.payload.selectedLocationIds, locationId: action.payload.locationId }) });
        }
        case 'setDate': {
            return Object.assign(Object.assign({}, state), { current: Object.assign(Object.assign({}, state.current), { date: (_a = action.payload.date) !== null && _a !== void 0 ? _a : '' }) });
        }
        case 'setDayOfWeek': {
            return Object.assign(Object.assign({}, state), { current: Object.assign(Object.assign({}, state.current), { dayOfWeek: action.payload.dayOfWeek }) });
        }
        case 'setTimeOfDay': {
            return Object.assign(Object.assign({}, state), { current: Object.assign(Object.assign({}, state.current), { timeOfDay: action.payload.timeOfDay }) });
        }
        case 'setDateInvalid': {
            return Object.assign(Object.assign({}, state), { current: Object.assign(Object.assign({}, state.current), { dateInvalid: action.payload.dateInvalid }) });
        }
        case 'apply':
            return state;
        case 'clear':
        default:
            return Object.assign(Object.assign({}, state), { current: action.payload });
    }
};
const BaseCollapsibleFilters = (_a) => {
    var { initialState, offsetTop, intl, onExpand, onCollapse, onApplyFilters, onClearFilters, onSelectedLocationChange, onDateChange, onDayOfWeekChange, onTimeOfDayChange, config } = _a, props = __rest(_a, ["initialState", "offsetTop", "intl", "onExpand", "onCollapse", "onApplyFilters", "onClearFilters", "onSelectedLocationChange", "onDateChange", "onDayOfWeekChange", "onTimeOfDayChange", "config"]);
    const withDefaults = (0, defaultsDeepAll_1.default)([
        initialState,
        {
            filterCount: 0,
            dateInvalid: false,
            dayOfWeek: [],
            highlightedLocId: null,
            locationId: null,
            locsByAvailability: null,
            date: '',
            mapUrl: null,
            selectedLocationIds: new Set([]),
            timeOfDay: TimeFilter_1.TIME_OF_DAY.ALL,
            visit_method: null
        }
    ]);
    const [state, dispatch] = (0, react_1.useReducer)(reducer, {
        initial: withDefaults,
        current: withDefaults
    });
    const color = react_1.default.useMemo(() => (0, ui_theme_1.fromTheme)('color_info')(props), []);
    const size = react_1.default.useMemo(() => (0, ui_theme_1.fromTheme)('font_size_heading_3')(props), []);
    const handleSelectedLocationChange = (0, react_1.useCallback)((selectedLocationIds, locationId) => {
        dispatch({
            type: 'setSelectedLocations',
            payload: {
                selectedLocationIds,
                locationId
            }
        });
        if (onSelectedLocationChange) {
            onSelectedLocationChange(selectedLocationIds, locationId);
        }
    }, [onSelectedLocationChange]);
    const setDateInvalid = (0, react_1.useCallback)((dateInvalid) => {
        dispatch({ type: 'setDateInvalid', payload: { dateInvalid } });
    }, []);
    const handleDateChange = (0, react_1.useCallback)((date) => {
        dispatch({
            type: 'setDate',
            payload: {
                date: date === null || date === void 0 ? void 0 : date.format('YYYY-MM-DD')
            }
        });
        if (onDateChange) {
            onDateChange(date === null || date === void 0 ? void 0 : date.format('YYYY-MM-DD'));
        }
    }, [onDateChange]);
    const handleDayOfWeekChange = (0, react_1.useCallback)((_, dayOfWeek) => {
        dispatch({
            type: 'setDayOfWeek',
            payload: {
                dayOfWeek
            }
        });
        if (onDayOfWeekChange) {
            onDayOfWeekChange(dayOfWeek);
        }
    }, [onDayOfWeekChange]);
    const handleTimeOfDayChange = (0, react_1.useCallback)((_, timeOfDay) => {
        dispatch({
            type: 'setTimeOfDay',
            payload: {
                timeOfDay
            }
        });
        if (onTimeOfDayChange) {
            onTimeOfDayChange(timeOfDay);
        }
    }, [onTimeOfDayChange]);
    const handleClearFilters = (0, react_1.useCallback)(() => {
        dispatch({ type: 'clear', payload: initialState });
        if (onClearFilters) {
            onClearFilters(state.current);
        }
    }, [initialState, onClearFilters, state]);
    const handleApplyFilters = (0, react_1.useCallback)(() => {
        dispatch({ type: 'apply' });
        if (onApplyFilters) {
            onApplyFilters(state.current);
        }
    }, [onApplyFilters, state]);
    return (react_1.default.createElement(CollapsibleFilters_styles_1.Accordion, Object.assign({ mode: "single", defaultExpanded: false, offsetTop: offsetTop, headerText: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SortFilter_1.default, { "aria-hidden": "true", color: color, size: size }),
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({ tagName: "span" }, messages_1.default.apptTimeFilterAppointments, { values: { filterCount: state.current.filterCount } }))), onExpand: onExpand, onCollapse: onCollapse }, props),
        react_1.default.createElement(styles_1.MapContainer, { "data-testid": "Map" }, (0, utils_1.hasAnyVideoPhoneAppt)(state.current.visit_method) ? (react_1.default.createElement(styles_1.ApptTimeLeftContainer, null,
            react_1.default.createElement(VisitTypeContent_1.default, { type: state.current.visit_method }))) : (react_1.default.createElement(styles_1.MapContent, null,
            react_1.default.createElement(CollapsibleFilters_styles_1.LocationsList, { selectedLocationIds: state.current.selectedLocationIds, highlightedLocId: state.current.highlightedLocId, url: state.current.mapUrl, bookableLocations: state.current.locsByAvailability.bookable, nonBookableLocations: state.current.locsByAvailability.nonBookable, onSelect: handleSelectedLocationChange, locationId: state.current.locationId, config: config })))),
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterAvailableDates), (FormattedMessage) => (react_1.default.createElement(CollapsibleFilters_styles_1.SectionHeader, null, FormattedMessage))),
        react_1.default.createElement(CollapsibleFilters_styles_1.Toolbar, { className: "FiltersToolbar" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterStartDate), (FormattedMessage) => (react_1.default.createElement(CollapsibleFilters_styles_1.FilterLabel, { htmlFor: "FilterJumpToDateCalendar" }, FormattedMessage))),
            react_1.default.createElement(JumpToDate_1.JumpToDate, { ariaLabel: intl.formatMessage(messages_1.default.ariaJumpToDateCalendarInput), date: state.current.date && (0, moment_1.default)(state.current.date), dateInvalid: state.current.dateInvalid, hideKeyboardShortcutsPanel: true, id: "FilterJumpToDateCalendar", inputIconPosition: "after", numberOfMonths: 1, onDateChange: handleDateChange, onFocusChange: () => { }, placeholder: intl.formatMessage(messages_1.default.apptTimeCalendarPlaceholder), screenReaderInputMessage: intl.formatMessage(messages_1.default.ariaJumpToDateInputDescription), setDateInvalid: setDateInvalid, showDefaultInputIcon: true, small: true }),
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterDayOfWeek), (FormattedMessage) => (react_1.default.createElement(CollapsibleFilters_styles_1.FilterLabel, { id: "FilterDayOfWeekLabel" }, FormattedMessage))),
            react_1.default.createElement(CollapsibleFilters_styles_1.SegmentedButtonGroup, { id: "FilterDayOfWeek", "data-testid": "WeekDayFilter", "aria-labelledby": "FilterDayOfWeekLabel", type: "multiple", value: state.current.dayOfWeek, onClick: handleDayOfWeekChange, isEqualFn: isEqual_1.default }, WeekDayFilter_1.DAYS_OF_WEEK.map((day, index) => (react_1.default.createElement(button_1.SegmentedButton, { key: day, value: index, "aria-label": day }, day.charAt(0))))),
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterTimeOfDay), (FormattedMessage) => (react_1.default.createElement(CollapsibleFilters_styles_1.FilterLabel, { id: "FilterTimeOfDayLabel" }, FormattedMessage))),
            react_1.default.createElement(CollapsibleFilters_styles_1.SegmentedButtonGroup, { id: "FilterTimeOfDay", "data-testid": "TimeFilter", "aria-labelledby": "FilterTimeOfDayLabel", type: "single", value: state.current.timeOfDay, onClick: handleTimeOfDayChange, isEqualFn: isEqual_1.default }, Object.keys(TimeFilter_1.TIME_OF_DAY).map((time) => (react_1.default.createElement(button_1.SegmentedButton, { key: time, value: time },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default[`timeOfDay.${time.toLowerCase()}`]))))))),
        react_1.default.createElement(CollapsibleFilters_styles_1.ButtonContainer, null,
            react_1.default.createElement(button_1.default, { mode: "ghost", onClick: handleClearFilters, "data-testid": "ClearFilters" },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterClearFilters))),
            react_1.default.createElement(button_1.default, { mode: "primary", "data-testid": "ApplyFilters", disabled: state.current.dateInvalid, onClick: handleApplyFilters },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterApplyFilters))))));
};
exports.CollapsibleFilters = (0, intl_1.injectIntl)(BaseCollapsibleFilters);
//# sourceMappingURL=CollapsibleFilters.js.map